import { graphql, useStaticQuery } from 'gatsby';

import { useFlatten } from './use-flatten';
import { getProperty } from 'utils';

export const useStaticInfo = () => {
	const results = useStaticQuery(query) || {};
	const key = 'squidex.findInfoSingleton';

	return useFlatten(getProperty(results, key) || {});
};

const query = graphql`
	query useInfoQuery {
		squidex {
			findInfoSingleton {
				id
				data {
					seo {
						de {
							title
							description
						}
					}

					header {
						de {
							title
						}
					}

					content {
						de {
							title
							text
							noInfos
							noFilesInInfo
						}
					}
				}
			}
		}
	}
`;
